<template>
  <div
    id="page-container"
    class="overflow-hidden d-flex"
    ref="creatives-page"
    :style="{ height: pageHeight }"
  >
    <div
      v-if="isPageLoading"
      class="loader align-self-center mx-auto"
    />
    <template
      v-else
    >
      <div
        class="flex-grow-1"
        v-if="showManageTrackersView"
      >
        <manage-trackers @manageTrackersPreviousStep="manageTrackersPreviousStep" />
      </div>
      <template
        v-else
      >
        <articles-section
          @openCommentsTab="openCommentsTab()"
        />
        <template v-if="creatives.length > 0">
          <div
            class="flex-grow-1 overflow-hidden"
          >
            <creatives-preview
              class="w-100 h-100"
              @showManageTrackers="showManageTrackers()"
              @setIsSidebarOpen="setIsSidebarOpen($event)"
              :is-sidebar-open="isSidebarOpen"
            />
          </div>
          <div
            class="display-properties-sidebar-container h-100 flex-shrink-0"
          >
            <display-properties-sidebar
              class="display-properties-sidebar"
              @setIsSidebarOpen="setIsSidebarOpen($event)"
              :is-sidebar-open="isSidebarOpen"
              :selected-tab-id="selectedTabId"
            />
          </div>
        </template>
        <template v-else>
          <div class="loader mx-auto" />
        </template>
      </template>
    </template>
    <creative-type-modal
      @previous-step="onPreviousStep"
    />
  </div>
</template>
<script>
import {
  mapGetters, mapState, mapActions, mapMutations,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import ArticlesSection from '@/modules/content/components/CreativesPage/ArticlesSection/ArticlesSection';
import CreativesPreview from '@/modules/content/components/CreativesPage/CreativesPreview';
import DisplayPropertiesSidebar from '@/modules/content/components/CreativesPage/Sidebar/DisplayPropertiesSidebar';
import ManageTrackers from '@/modules/campaigns/components/ManageTrackers';
import CreativeTypeModal from '@/modules/content/components/CreativesPage/Sidebar/CreativeType/CreativeTypeModal';

export default {
  name: 'CreativesPage',
  components: {
    ArticlesSection,
    CreativesPreview,
    CreativeTypeModal,
    DisplayPropertiesSidebar,
    ManageTrackers,
  },
  data() {
    return {
      isPageLoading: true,
      pageHeight: 0,
      showManageTrackersView: false,
      isSidebarOpen: false,
      selectedTabId: null,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'creatives',
      'isAddingNewAnnotation',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_VIEW_TYPE,
      campaignTypes.GET_IS_MANAGED_CAMPAIGN,
    ]),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_CREATIVE_SIZES,
    ]),
    ...mapActions('content', [
      contentTypes.FETCH_CREATIVE_TEMPLATES,
      contentTypes.REMOVE_CURRENT_ANNOTATION,
      contentTypes.SET_SELECTED_ARTICLE_UUID,
    ]),
    ...mapMutations('content', [
      contentTypes.TOGGLE_ANNOTATIONS,
    ]),
    showManageTrackers() {
      this.showManageTrackersView = true;
    },
    manageTrackersPreviousStep() {
      this.showManageTrackersView = false;
    },
    updatePageHeight() {
      this.pageHeight = `${window.innerHeight - 134}px`;
    },
    setIsSidebarOpen(isOpen, selectedTabId) {
      this.isSidebarOpen = isOpen;
      this.selectedTabId = selectedTabId;
      if (!isOpen) {
        if (this.isAddingNewAnnotation) this.REMOVE_CURRENT_ANNOTATION();
        this.TOGGLE_ANNOTATIONS(false);
      }
    },
    openCommentsTab() {
      this.setIsSidebarOpen(true, 'creative-template-comments');
    },
    async fetchCreativeTemplates() {
      const payload = {
        templateGroupId: this.campaign.templateGroupId,
        campaignId: this.campaign.id,
      };
      if (this.GET_IS_MANAGED_CAMPAIGN) delete payload.campaignId;
      else delete payload.templateGroupId;
      return await this.FETCH_CREATIVE_TEMPLATES(payload);
    },
    onPreviousStep() {
      this.$emit('previous-step');
    },
  },
  mounted() {
    if (!this.creatives.length) {
      this.$root.$emit('bv::show::modal', 'creative-type-modal');
    }
  },
  async created() {
    if (this.GET_IS_VIEW_TYPE('Setup')) {
      this.pageHeight = `${window.innerHeight - 134}px`;
      window.addEventListener('resize', this.updatePageHeight);
    } else {
      this.pageHeight = '100%';
    }
    await this.FETCH_CREATIVE_SIZES();
    await this.fetchCreativeTemplates();
    this.isPageLoading = false;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updatePageHeight);
  },
};
</script>
<style scoped lang="scss">
.display-properties-sidebar-container {
  position: relative;
  width: 50px !important;
}
.display-properties-sidebar {
  position: absolute;
  right: 0;
}
.loader {
  height: 100%;
}
</style>
